// Small shopping-basket glyph used on the pending "Add to Basket" bars across
// the Order Guide and Catalog pages so the call-to-action reads at a glance.
// `light` flips it white for use on the red button.
export default function BasketIcon({ light }) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
      stroke={light ? '#fff' : '#A50B18'} strokeWidth="2"
      strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }} aria-hidden="true">
      <path d="M5 8h14l-1.2 9.2a2 2 0 0 1-2 1.8H8.2a2 2 0 0 1-2-1.8L5 8Z" />
      <path d="M9 8 12 3l3 5" />
      <path d="M9.5 12v3M14.5 12v3" />
    </svg>
  );
}
